import { SettingKeys } from '@/models/tenant-settings/tenant-settings';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { isAPICatchError, isEmpty } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'add-keys',
    components: {

    },
})

export default class AddKeys extends Vue {

    @Prop()
    private isEditMode: any;

    @Prop()
    private keysData: any;

    private newOptionObject: any = {
        text: '',
        value: '',
        is_default: false,
    };

    private showDropdownButton: boolean = false;

    private selectedDefault: any = '';

    private formFields: any = {
        setting_key: {
            name: 'Setting Key',
            field: 'b-form-input',
            modelKey: 'setting_key',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
            isDisabled: false,
        },
        display_name: {
            name: 'Display name',
            field: 'b-form-input',
            modelKey: 'display_name',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        group_name: {
            name: 'Group name',
            field: 'b-form-input',
            modelKey: 'group_name',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        subgroup_name: {
            name: 'Sub group name',
            field: 'b-form-input',
            modelKey: 'subgroup_name',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
        description: {
            name: 'Description',
            field: 'b-form-textarea',
            modelKey: 'description',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        update_warning_message: {
            name: 'Update warning message',
            field: 'b-form-textarea',
            modelKey: 'update_warning_message',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
        access_mode: {
            name: 'Access mode',
            field: 'b-form-select',
            modelKey: 'access_mode',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
            propBind: {
                options: [
                    { text: 'Edit only by admin', value: 'edit-only-by-admin' },
                    { text: 'Edit', value: 'edit' },
                    { text: 'View', value: 'view' },
                ],
            },
        },
        default_value: {
            name: 'Default value',
            field: 'b-form-input',
            modelKey: 'default_value',
            modelValue: '',
            validate: { required: false },
            eventBind: {},
        },
        sequence_id: {
            name: 'Sequence id',
            field: 'b-form-input',
            modelKey: 'sequence_id',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
            propBind: {
                type: 'number',
                min: 0,
            },
        },
        setting_visibility: {
            name: 'Setting visibility',
            field: 'b-form-select',
            modelKey: 'setting_visibility',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
            propBind: {
                options: [
                    {
                        text: 'Private',
                        value: 'private',
                    },
                    {
                        text: 'Public',
                        value: 'public',
                    },
                ],
            },
        },
        ui_element_type: {
            name: 'Ui element type',
            field: 'b-form-select',
            modelKey: 'ui_element_type',
            modelValue: '',
            validate: { required: true },
            eventBind: { change: this.onChangeUIElementType.bind(this) },
            propBind: {
                options: [
                    {
                        text: 'Input text',
                        value: 'input-text',
                    },
                    {
                        text: 'Input json',
                        value: 'input-json',
                    },
                    {
                        text: 'Toggle boolean',
                        value: 'toggle-boolean',
                    },
                    {
                        text: 'Toggle string',
                        value: 'toggle-string',
                    },
                    {
                        text: 'Taxonomy picker',
                        value: 'taxonomy-picker',
                    },
                ],
            },
        },
        is_global: {
            name: 'Is Global',
            field: 'b-form-checkbox',
            modelKey: 'is_global',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
            propBind: {
                switch: true,
            },
        },
    };

    private settingDetails: SettingKeys = {
        access_mode: '',
        default_value: '',
        description: '',
        display_name: '',
        group_name: '',
        is_global: false,
        sequence_id: 0,
        setting_key: '',
        setting_visibility: '',
        subgroup_name: '',
        ui_element_type: '',
        update_warning_message: '',
        select_option: null,
    };

    private showError: boolean = false;

    private selectDefaultError: boolean = false;

    private optionsFieldsList = [
        {
            key: 'index',
            label: 'S.No',
            thClass: 'sticky-position',
        },
        {
            key: 'text',
            label: 'Property name',
            thClass: 'sticky-position',
            sortable: true,
        },
        {
            key: 'value',
            label: 'Property value',
            thClass: 'sticky-position',
            sortable: true,
        },
        {
            key: 'is_default',
            label: 'Select Default',
            thClass: 'sticky-position',
            sortable: true,
        },
        {
            key: 'remove',
            label: 'Remove',
            thClass: 'sticky-position',
            sortable: true,
        },
    ];

    private optionsList: any = [];

    private isSubmitted: boolean = false;

    private created() {
        this.resetOptionObject();
        if (this.isEditMode) {
            this.formFields.setting_key.isDisabled = true;
            this.mapExistingData();
        }
    }

    private onSwitchComponent(key: any) {
        this.$emit('onSwitchComponent', key);
    }

    private inputValidator(errors: any, keyName: string) {
        return this.isSubmitted && errors.has(keyName);
    }

    private saveKeyData() {
        this.isSubmitted = true;
        this.$validator.validate().then((valid) => {
            if (valid) {
                if (this.showDropdownButton && this.settingDetails.select_option &&
                    this.settingDetails.select_option.options &&
                    this.settingDetails.select_option.options.length === 0
                ) {
                    this.settingDetails.select_option = null;
                }
                if (!this.showDropdownButton) {
                    this.settingDetails.select_option = null;
                }
                if (this.isEditMode) {
                    this.settingDetails.setting_key = this.keysData.settingKey;
                    adminUtilsAPI.updateSettingKey(this.settingDetails).then((data: any) => {
                        if (!isAPICatchError(data)) {
                            this.resetCompletly();
                            this.onSwitchComponent('keys-list');
                        }
                    });
                } else {
                    adminUtilsAPI.saveSettingKey(this.settingDetails).then((data: any) => {
                        if (!isAPICatchError(data)) {
                            this.resetCompletly();
                            this.onSwitchComponent('keys-list');
                        }
                    });
                }
            }
        });
    }

    private mapExistingData() {
        this.settingDetails.access_mode = this.keysData.accessMode;
        this.settingDetails.default_value = this.keysData.defaultValue;
        this.settingDetails.description = this.keysData.description;
        this.settingDetails.display_name = this.keysData.displayName;
        this.settingDetails.group_name = this.keysData.groupName;
        this.settingDetails.is_global = this.keysData.isGlobal;
        this.settingDetails.sequence_id = this.keysData.sequenceId;
        this.settingDetails.setting_key = this.keysData.settingKey;
        this.settingDetails.setting_visibility = this.keysData.settingVisibility;
        this.settingDetails.subgroup_name = this.keysData.subGroupName;
        this.settingDetails.ui_element_type = this.keysData.uiElementType;
        this.settingDetails.update_warning_message = this.keysData.updateWarningMessage;
        this.settingDetails.select_option = this.keysData.selectOption;
        if (this.keysData.uiElementType === 'input-text' ) {
            this.showDropdownButton = true;
            if (this.keysData.selectOption && this.keysData.selectOption.options) {
                this.optionsList = this.keysData.selectOption.options;
                const searchOption = this.optionsList.find((item: any) => item.is_default);
                if (searchOption && searchOption.value) {
                    this.selectedDefault = searchOption.value;
                }
            }
        } else {
            this.showDropdownButton = false;
        }
    }

    private hideModal() {
        this.$bvModal.hide('add-key-options');
    }

    private showModal() {
        this.resetOptionObject();
        this.$bvModal.show('add-key-options');
    }

    private resetCompletly() {
        this.showError = false;
        this.optionsList = [];
        this.selectedDefault = '';
        this.resetOptionObject();
    }

    private resetOptionObject() {
        this.newOptionObject = {
            text: '',
            value: '',
            is_default: false,
        };
        this.selectDefaultError = false;
    }

    private add() {
        if (isEmpty(this.newOptionObject.text) || isEmpty(this.newOptionObject.value)) {
            return;
        }
        const option: any = {
            text: this.newOptionObject.text,
            value: this.newOptionObject.value,
            is_default: false,
        };
        const searchIndex = this.optionsList.findIndex((item: any) => item.value === option.value);
        if (searchIndex !== -1) {
            this.showError = true;
            return;
        }
        this.optionsList.push(option);
        this.resetOptionObject();
        this.showError = false;
    }

    private remove(item: any) {
        const itemIndex = this.optionsList.findIndex((listItem: any) => item.value === listItem.value);
        if (itemIndex !== -1) {
            this.optionsList.splice(itemIndex, 1);
        }
    }

    private changeDefault(item: any) {
        for (const iterator of this.optionsList) {
            iterator.is_default = false;
        }
        item.is_default = true;
        this.selectedDefault = item.value;
    }

    private addDone() {
        this.selectDefaultError = false;
        if (this.optionsList && this.optionsList.length > 0) {
            if (isEmpty(this.selectedDefault)) {
                this.selectDefaultError = true;
                return;
            }
            this.settingDetails.select_option = {
                options: this.optionsList,
            };
        }
        this.hideModal();
    }

    private onChangeUIElementType(value: any) {
        if (value === 'input-text') {
            this.showDropdownButton = true;
        } else {
            this.showDropdownButton = false;
        }
    }
}
